import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
// most of this was copied from prop-types
var loggedFailures = {};

/** global settings object * */
var settings = {
  warningLimit: 2,
  // eslint-disable-next-line no-console
  logMethod: console && console.error,
  isEnabled: process.env.NODE_ENV !== 'production'
};
var printWarningDebug = function printWarningDebug(text, code) {
  loggedFailures[code] = loggedFailures[code] ? loggedFailures[code] + 1 : 1;
  if (loggedFailures[code] >= settings.warningLimit) {
    return;
  }
  var message = "Warning: ".concat(text);
  if (settings.logMethod) {
    settings.logMethod(message, code);
  }
  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {
    /**/
  }
};
var printWarningProd = function printWarningProd() {};
var printWarning = function printWarning(text, code) {
  return settings.isEnabled ? printWarningDebug(text, code) : printWarningProd();
};
function deprecationWarning(options) {
  var component = options.component,
    propName = options.propName,
    info = options.info,
    code = options.code;
  var name = component.displayName || component.name;
  var message = "<".concat(name, "> prop '").concat(propName, "' is deprecated and will be removed in the next major version release.\n").concat(info);
  printWarning(message, code);
}
function removalWarning(options) {
  var component = options.component,
    propName = options.propName,
    info = options.info,
    code = options.code;
  var name = component.displayName || component.name;
  var message = "".concat(name, " prop '").concat(propName, "' has been removed from LMDS.\n").concat(info);
  printWarning(message, code);
}
export default deprecationWarning;
export { printWarning, deprecationWarning, removalWarning, settings };